
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_61574_22706)"}},[_c('path',{attrs:{"d":"M6.09.25l.078.004a.75.75 0 010 1.492l-.077.004H1.75v12.5h4.34l.078.004a.75.75 0 010 1.492l-.077.004H1A.75.75 0 01.25 15V1L.254.923A.75.75 0 011 .25h5.09zm5.2 4.04a.75.75 0 011.004-.052l.057.052 3.165 3.165a.726.726 0 01.086.099c.094.125.15.278.15.446a.745.745 0 01-.03.196.74.74 0 01-.138.28l-.052.056-3.181 3.182a.75.75 0 11-1.061-1.06l1.903-1.904h-7.1a.75.75 0 010-1.5h7.097l-1.9-1.9-.052-.056a.75.75 0 01.052-1.004z","fill":"#4A4A4A"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_61574_22706"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    